export const MESSAGES = {
  DAY_LOAD_ERROR: "Failed to load day data",
  COMMENT_UPDATE_SUCCESS: "Comment updated successfully",
  COMMENT_UPDATE_ERROR: "Failed to update comment",
  TASK_SUCCESS: "Task Loaded successfully.",
  TASK_FAILURE: "Task Loading failed. Please try again.",
  USER_FETCH_ERROR: "Failed to fetch users",
  NO_HISTORY: "No History Found",
  DOWNLOAD_FAILED: "Unable to download File",
  NO_DATA_AVAILABLE: "No data available to download",
  EXCEL_DOWNLOAD_SUCCESSFUL: "Excel downloaded Successfully",
  SAVED_TO_DEVICE: "Data has been saved to the Device",
  TASK_ADDED: "Task is Added Successfully",
  TASK_COMPLETED: "Task is Completed Successfully",
  LOCATION_DENIED_ERROR: "Cannot get location",
  STARTED_DAY: "Day started successfully!",
  ENDED_DAY: "Day ended successfully!",
  FAILED_SUBMISSION: "Failed to submit data.",
  MAP_LOADING_ERROR: "Error Loading Map",
  INVALID_DAY_ID: "Could not get Day Id",
  TASK_DETAILS_MISSING: "Task details are Missing",
  ACTION_CONFIRMATION: "This will result in your day completion. Do you want to proceed?",
};

export const STATUS_DISPLAY = {
    IN_PROGRESS: "In Progress",
    COMPLETED: "Completed",
    COMPLETED_BY_ADMIN: "Completed by Admin",
}
